<template>
  <div class="room"
       data-grm-comp="Room"
       :data-roomid="room.roomId"
       :data-groupid="room.groupId"
       :data-roomType="room.roomType"
       :data-open-extend-menu="isOpenExtendMenu"
  >
    <template v-if="readyToEnter && !isLeaved">
      <RoomMenu
        :isOpenExtendMenu="isOpenExtendMenu"
        :isOpenRoomStickerModal.sync="isOpenRoomStickerModal"
      />
      <div class="room-container">
        <RoomControls
          :isOpenExtendMenu.sync="isOpenExtendMenu"
        />
        <div style="flex: 1; min-height: 0; display: flex">
          <div class="room-main">
            <RoomCallAudio />
            <transition-group name="fade">
              <component class="room-main-component" key="room-main" v-if="!isRoomMode('media')" :is="roomMainComponent" />
            </transition-group>
            <!-- 미디어 공유는 show로 수정 -->
            <transition name="fade" v-if="!!roomMode">
              <RoomMediaShare class="room-main-component" ref="mediaShare" v-show="isRoomMode('media')"/>
            </transition>

            <RoomCallConnectionState
                style="position: absolute; z-index: 10; top: 0px; left: 0; pointer-events: none;"
                v-if="$store.state.call.showConnectionStats === true"
            />

            <Loading v-if="showRoomConnectionStateLoading" :msg="$t('room.connectionState.msg.' + connectionState)" />
            <GrmSnackbarList :isOpenExtendMenu="isOpenExtendMenu" />
          </div>
          <RoomExtendMenu :class="{ isOpen: isOpenExtendMenu }"
                          @closeExtendMenu="closeExtendMenu"
                          @toggleNewWindowMenu="toggleNewWindowMenu"
                          @transitionend.native="onTransitionend"
                          ref="roomExtendMenu"/>
          <RoomWindowOpen
              ref="newWindowMenu"
              :title="`[Gooroomee-PIP] ${$t('setting.chat.title')}`"
              :width="320"
              :minWidth="320"
              :height="800"
              :minHeight="800"
          >
            <RoomExtendMenu
                :chatHistoryProp="chatHistory()"
                newWindow/>
          </RoomWindowOpen>

          <RoomNotification :isOpenExtendMenu="isOpenExtendMenu"
                            @openExtendMenu="isOpenExtendMenu = true"
          />
        </div>
      </div>
      <transition-group name="fade">
<!--        <RoomSetting class="room-setting-layer"-->
<!--            v-if="isOpenRoomSetting"-->
<!--            key="room-setting"-->
<!--            :isOpenRoomSetting.sync="isOpenRoomSetting"-->
<!--        />-->
        <RoomStickerModal
          v-if="isOpenRoomStickerModal"
          key="room-sticker-modal"
          class="slide-right"
        />
      </transition-group>
    </template>
    <template v-else>
      <RoomDeviceSetting
          v-if="isShowSetDevice"
          :roomInfo="room"
          :deviceSettings="deviceSettings"
          isDevicetest
          ref="waitingRoom"
      />
    </template>
  </div>
</template>

<script>
import {} from "@/core/api/room.ux.api";
import {} from "@/core/api/room.call.api"
import {} from "@/core/api/room.call.p2p.api"
import {} from "@/core/api/room.call.mixer.api"
import {} from "@/core/api/room.call.mixer.sfu.api"
import {} from "@/core/api/room.call.stream.api"
import {} from "@/core/api/room.call.layout.api"
import {} from "@/core/api/room.call.log.api"
import {} from "@/core/api/room.doc.api"
import {} from "@/core/api/room.group.api"
import {} from "@/core/api/room.chat.api";
import {} from "@/core/api/room.question.api";
import {} from "@/core/api/room.goalSchedule.api";
import {} from "@/core/api/room.testbank.api";
import {} from "@/core/api/room.shareNote.api";
import {} from "@/core/api/room.note.api";
import {} from "@/core/api/room.translation.api";
import {} from "@/core/api/room.user.behavior.api";
import {} from "@/core/api/group.api";

import _ from "lodash";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import RoomMenu from '@/components/Room/Menu/RoomMenu.vue'
// import RoomSetting from '@/components/Room/Setting/RoomSetting.vue'
import RoomControls from '@/components/Room/Controls/RoomControls.vue'
import RoomCallSubVideo from '@/components/Room/Call/SubVideo'
import RoomExtendMenu from '@/components/Room/ExtendMenu/RoomExtendMenu'
import RoomCall from '@/components/Room/Call/RoomCall'
import RoomDocShare from '@/components/Room/Doc/Share'
import RoomMediaShare from '@/components/Room/Media/Share'
import RoomExam from '@/components/Room/Exam/RoomExam.vue'
import RoomCBT from '@/components/Room/CBT/RoomCBT.vue'
import RoomStickerModal from '@/components/Room/Sticker/Modal'
import ModalInvite from "@/components/Room/Invite/RoomInvite";
import RoomCallConnectionState from "@/components/Room/Call/RoomCallConnectionState";
import RoomMirroring from "@/components/Room/Mirroring/RoomMirroring";
import RoomDeviceSetting from "@/components/Room/DeviceSetting/RoomDeviceSetting";
import RoomWindowOpen from "@/components/Room/Window/RoomWindowOpen";
import RoomJoinGuest from "@/components/Room/Join/RoomJoinGuest";
import Loading from "@/components/Common/loading/GrmLoading.vue"

import commonEventListener from "@/store/plugins/common.event.listener";
import roomEventListener from "@/store/plugins/room.event.listener";

import {closeWindow} from "@/core/api/util.api";
import {Device} from "@/utils";
import GrmSnackbarList from "@/components/Common/snackbar/GrmSnackbarList";
import RoomNotification from "@/components/Room/Notification/RoomNotification";
import RoomCallP2P from "@/components/Room/Call/p2p/RoomCallP2P.vue";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import RoomCallAudio from "@/components/Room/Call/RoomCallAudio.vue";

export default {
  name: "Room",
  props: {
    room: Object,
  },
  components: {
    RoomCallAudio,
    RoomCallP2P,
    RoomNotification,
    GrmSnackbarList,
    RoomMenu,
    // RoomSetting,
    RoomControls,
    RoomCallSubVideo,
    RoomExtendMenu,
    RoomCall,
    RoomDocShare,
    RoomMediaShare,
    RoomExam,
    RoomCBT,
    RoomStickerModal,
    ModalInvite,
    RoomDeviceSetting,
    RoomCallConnectionState,
    RoomMirroring,
    RoomWindowOpen,
    Loading
  },
  data() {
    return {
      rv_test: true,

      readyToEnter: false,
      isShowSetNickname: false,
      isLeaveRoom: false,
      isSetDeviceLoading: false,
      isShowSetDevice: false,
      passwd: '',

      // deviceSettings: null,
      user: null,
      roomUserNickname: '',
      enterReq: {
        nickname: ''
      },

      // 3.0
      isOpenExtendMenu: !Device.isMobile(),
      // isOpenRoomSetting: false,
      isOpenRoomStickerModal: false,
    }
  },
  computed: {
    ...mapGetters('room', [
        'connectionState',
        'isLeaved',
        'roomDataInitComplete', 'deviceSettings',
        'isRoomMode',
        'roomMode',
        'isModalDeviceSetting',
    ]),
    ...mapGetters('common', [
      'notify',
      'alert',
      'isOpenVoiceRequest'
    ]),
    ...mapGetters('user', [
       'isMe',
       'hasEmceeRole',
       'getRoomUser',
       'isOpener',
       'isParticipantRole',
       'me'
    ]),
    ...mapGetters('roomSetting',['roomSetting']),
    ...mapState('cbt', [
      'roomCBT'
    ]),

    chatHistory(){
      return ()=>{
        return this.$refs.roomExtendMenu?.chatHistory;
      }
    },
    roomId() {
      return this.room?.room?.roomId
    },
    roomMainComponent() {
      switch (this.roomMode) {
        case 'call':
        case 'screenShare':
        case 'group':
          return 'RoomCall'
        case 'doc':
          return 'RoomDocShare'
        case 'media':
          return 'RoomMediaShare'
        case 'exam':
          return 'RoomExam'
        case 'CBT':
          return this.roomCBT.roomCbtId ? 'RoomCBT' : ''
        case 'mirroring':
          return 'RoomMirroring'
        default:
          return ''
      }
    },
    showRoomConnectionStateLoading() {
      const loadingConnectionStates = ['ready', 'retry'];
      return loadingConnectionStates.includes(this.connectionState);
    },
  },
  async created() {
    this._events = _.clone(_Events);
    this.$roomApi.addEventListeners(this._events, this);
    this.getDocument().addEventListener('fullscreenchange', this.onFullscreenChange);

    // test
    window.$rv = this;

    await this.roomEnter();
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._events);
    this.getDocument().removeEventListener('fullscreenchange', this.onFullscreenChange);
  },
  methods: {
    ...mapActions('room', [
      'enter',
      'reloadRoom',
      'checkSilentReload',
      'saveDeviceSettings',
      'getRoom',
      'unsetBeforeUnloadEvent',
      'setRoomInfo',
      'reqLeave'
    ]),
    ...mapActions('user', [
      'getMyNickname'
    ]),
    ...mapActions('auth', [
      'guestLogin',
      'currentUser'
    ]),
    ...mapActions('ux', [
      'setUXInfo',
    ]),
    ...mapMutations('room', [
       'SET_FULL_SCREEN',
       'ROOM_CONNECTED',
    ]),
    async roomEnter(options={}) {
      try {
        // dev
        console.log('[# 현재사용중인 API 서버 주소] : ',process.env.VUE_APP_API_URL);
        window.$roomVue = this
        window.$roomApi = this.$roomApi

        // room info
        let roomId = this.$route.params.roomId,
            roomUrlId = this.$route.params.roomUrlId

        if(!this.room || !this.room.roomId) {
           this.room = (
              await this.getRoom({ roomId, roomUrlId })
          ).data
        }

        roomId = this.room.roomId
        this.roomUserNickname = (
            await this.getMyNickname(this.room.roomId)
        ).data
        
        commonEventListener(this.$roomApi)(this.$store)
        roomEventListener(this.$roomApi)(this.$store)

        // 입장 전 Device Setting에서 RoomInfo init
        await this.setRoomInfo(this.room.roomId);

        // 입장 전 UXInfo init
        await this.setUXInfo(this.room.groupId);

        // TODO 장치 테스트 필요 없는 케이스
        let deviceSettings;
        if(!options.retry) {
          const RoomSilentReload = await this.checkSilentReload();
          console.log('# reload : silent[%s]', !!RoomSilentReload);
          if(RoomSilentReload){
            deviceSettings = RoomSilentReload.deviceSettings;
            if(deviceSettings && deviceSettings.cameraStatus !== undefined){
                const devices = await GrmWebRTC.getUserDevice();
                if(deviceSettings.micStatus === 'none'
                  && devices.audioinput && devices.audioinput.length > 0
                ){
                  deviceSettings.micStatus = 'off';
                }
                if(deviceSettings.cameraStatus === 'none'
                  && devices.videoinput && devices.videoinput.length > 0
                ){
                  deviceSettings.cameraStatus = 'off';
                }
            }
          }else{
            deviceSettings = await this.showSetDevice()
          }
          this.saveDeviceSettings({deviceSettings});
        }
        // use password
        if (this.room.definePasswd && !await this.isHost()) {
          this.passwd = await this.getPasswd();
        }


        if(deviceSettings){
          console.log('# deviceSettings :', JSON.stringify(deviceSettings, null, '  '));
        }else{
          deviceSettings = {...this.deviceSettings};
          console.log('# deviceSettings load default :', JSON.stringify(deviceSettings, null, '  '));
        }
        await this.enterToRoom({ roomId, roomUrlId }, deviceSettings)
      } catch (e) {
        switch (e.message) {
          case 'Empty Refresh Token Cookie':
            this.$modal(RoomJoinGuest, {
              data: {
                joinGuest: this.handleGuestLogin
              }
            });

            if(!this.room.enterGuest) {
              this.$alert({
                text: this.$t('room.joinFail'),
                ok: () => {
                  window.location.href = '/'
                },
                onlyOk: true
              })
            }
            return;
          case 'PASSWD_NOT_MATCHED':
          case 'PASSWD_REQUIRED':
            console.error(e);
            this.$alert({
              text: this.$t('room.password.fail'),
              ok: async () => {
                await this.roomEnter({retry: true});
              },
              onlyOk: true
            })
            return;
          case 'WAITING_ROOM_REQUIRED':
            this.$alert({
              text: this.$t('room.rejoin'),
              ok: async () => {
                window.location.href = '/'
              },
              onlyOk: true
            })
            // await this.enterToWaitingRoom(
            //     {
            //       roomId: this.room.roomId,
            //       roomUrlId: this.$route.params.roomUrlId,
            //     },
            //     this.deviceSettings
            // )
            return;
          case 'NONE_ROOM':
          case 'ENDED':
            this.$camsAlert({
              text: this.$t('room.closed'),
              ok: async () => {
                window.location.href = '/'
              },
              onlyOk: true
            })
            return;
          case 'NONE_ROOM_SETTING':
            this.$alert({
              text: this.$t('room.notExist'),
              ok: async () => {
                window.location.href = '/'
              },
              onlyOk: true
            })
            return;
          case 'DENY_DEVICE_TYPE':
            this.$alert({
              text: this.$t('room.deviceNotAllowed'),
              ok: async () => {
                window.location.href = '/'
              },
              onlyOk: true
            })
            return;
        }
        console.error(e)
        await this.$router.push({
          // name: 'login',
          name: 'roomEnterError',
          query: { redirect: location.pathname + location.hash }
        })
      }
    },
    // async enterToWaitingRoom(enterParams) {
    //   this.$refs.waitingRoom.connect(enterParams);
    // },
    async enterToRoom(options = {}, deviceSettings) {
      // create params
      let enterParams = _.merge(
        {
          roomId: this.$route.params.roomId,
          roomUrlId:
            this.$route.hash &&
            this.$route.hash.length > 0 &&
            this.$route.hash.substring(1),
          passwd: this.passwd,

          nickname:
            this.enterReq.nickname || this.roomUserNickname,

          cameraStatus: deviceSettings.cameraStatus || (
              deviceSettings.video.deviceId
                  ? 'on'
                  : (deviceSettings.video.deviceId === false ? 'none' : 'off')
          ),
          micStatus: deviceSettings.micStatus || (
              deviceSettings.audio.deviceId
                  ? 'on'
                  : (deviceSettings.audio.deviceId === false ? 'none' : 'off')
          ),
          speakerStatus: deviceSettings.speakerStatus || (
              deviceSettings.audiooutput.deviceId
                ? 'on'
                : (deviceSettings.audiooutput.deviceId === false ? 'none' : 'off')
          ),
          useNoiseCancel: deviceSettings.audio?.useNoiseCancel,
          networkType: Device.networkType(),
          deviceType: Device.isMobile() ? 'mobile' : 'pc',
          deviceModel: Device.deviceInfo().device?.model,
          osName: Device.deviceInfo().os?.name,
          osVersion: Device.deviceInfo().os?.version,
          clientType: Device.deviceInfo().client?.type,
          clientName: Device.deviceInfo().client?.name,
          clientVersion: Device.deviceInfo().client?.version,
        },
        options
      )

      await this.enter({
        enterParams,
        deviceSettings
      })

      this.readyToEnter = true
    },
    setUserNickname({ nickname }) {
      this.enterReq.nickname = nickname
    },
    leaveRoomToggle(state) {
      this.isLeaveRoom = state
    },
    async showSetDevice() {
      this.isShowSetDevice = true
      return new Promise((resolve, reject) => {
        try {
          this.$once('deviceTestComplete', settings => {
            this.isShowSetDevice = false
            console.log('# deviceTestComplete :', JSON.stringify(settings, null, '  '));
            resolve(settings)
          })
        } catch (e) {
          reject(e)
        }
      })
    },
    async handleGuestLogin(nickname){
      await this.guestLogin(nickname);
      this.$modal('RoomJoinGuest');
      await this.roomEnter();
    },
    async getPasswd(){
      return await new Promise((res, rej) => {
        try {
          this.$alert({
            title: this.$t('room.password.enter'),
            type: 'input',
            ok: (value) => {
              return res(value)
            },
            onlyOk: true
          })
        } catch(e) {
          console.log(e)
          return rej(e)
        }
      });
    },
    async isHost(){
      let curUser = await this.currentUser();
      let userId = curUser?.data?.user?.userId;

      if(userId == this.room.userId){
        return true;
      }else{
        return false;
      }
    },
    async kickRoomUser(e) {
      // await this.$roomApi.disconnectClient()

      // this.unsetBeforeUnloadEvent()
      // this.$el.remove()
      // this.$destroy()

      let kicker = this.$t('common.emcee');
      const roomUser = this.getRoomUser(e.userId);
      if (roomUser && roomUser.roomUserRole?.roleId) {
        if (this.isOpener(e.userId) && this.isParticipantRole(roomUser)) {
          kicker = this.$t('common.speaker');
        } else {
          kicker = this.$t(`common.${roomUser.roomUserRole.roleId}`);
        }
      }

      this.$alert({
        text: this.$t('room.ban.message.addRole', { '0' : kicker}),
        ok: () => {
          if (this.roomSetting.useClosingWindow) {
            window.close();
          } else {
            window.location.href = 'service/room';
          }
        },
        onlyOk: true
      })
    },
    closeExtendMenu(){
      this.isOpenExtendMenu = false;
    },
    toggleNewWindowMenu(){
      this.$refs.newWindowMenu.toggle()
    },
    onFullscreenChange(){
      this.SET_FULL_SCREEN(this.getDocument().fullscreen);
    },
    onTransitionend(){
      this.getDefaultView().dispatchEvent(new Event('resize'));
    },
  },
  watch: {
    rv_test(val) {
      if (val) {
        this.$refs.pipVideo.toggle();
      }
    },
    connectionState(state) {
      if(state === 'disconnected'){
        this.$confirm({
          text: this.$t('room.connectionState.msg.disconnected')
            + '<br>' + this.$t('room.connectionState.msg.reEnter'),
          ok: () => {
            this.reloadRoom({silent: false});
          },
          cancel: () => {
            this.reqLeave();
            closeWindow();
          }
        });
      }
    }
  },
}

const _Events = {
  room_reload(e) {
    this.reloadRoom({
        silent: !this.isShowSetDevice
    });
  },
  room_user_kickRoomUser(e) {
    this.kickRoomUser(e)
  },
  room_user_kickAllRoomUser(e) {
    if(!this.hasEmceeRole(this.me)) {
      this.kickRoomUser(e)
    }
  },
  noise_cancel_failed(data) {
    this.$alert({
      text: this.$t('room.noiseCancelFail'),
      onlyOk: true,
    })
  },
  room_stt_failed(e) {
    this.$alert({
      text: this.$t('room.roomSttFail'),
      onlyOk: true,
    })
  },
  room_data_init() {
    this.ROOM_CONNECTED();
  },
  room_leaved (e) {
      switch(e.data.reason){
          case 'duplicate':
              this.$alert({
                  text: this.$t('room.duplicateUser'),
                  ok: () => {
                      window.location.href = 'service/room'
                  },
                  onlyOk: true
              })
              break;
      }

      this.unsetBeforeUnloadEvent();
      this.$el.remove();
      this.$destroy()
  },
  room_user_leave (e) {
    const { userId, reason } = e.data
    if (!this.isMe(userId)) {
      return
    }

    switch(reason){
      case 'PROTOCOL_ERROR':
      case 'NO_CLOSE_FRAME':
        this.unsetBeforeUnloadEvent()
        location.reload()
        break
      default:
        break
    }
  },
  room_end (e) {
    this.unsetBeforeUnloadEvent();
    let exitTimer = setTimeout(() => {
      if (this.roomSetting.useClosingWindow) {
        window.close();
      } else {
        window.location.href = 'service/room';
      }
    }, 3000);

    this.$alert({
      text: this.$t('room.end'),
      ok: () => {
        clearTimeout(exitTimer);
        if (this.roomSetting.useClosingWindow) {
          window.close();
        } else {
          window.location.href = 'service/room';
        }
      },
      onlyOk: true
    })

  },
  room_doc_convertError (e) {
    if (this.isMe(e.userId)) {
      this.$alert({
        text: this.$t('doc.convert.fail.msg'),
        onlyOk: true
      });
    }
  },
  completed_meeting_note_summary (e) {
    if (this.isMe(e.userId)) {
      this.$alert({
        text: this.$t('extendMenu.meetingNote.summary.alert.event.completed'),
        onlyOk: true
      });
    }
  },
  failed_meeting_note_summary (e) {
    if (this.isMe(e.userId)) {
      this.$alert({
        text: this.$t('extendMenu.meetingNote.summary.alert.event.failed'),
        onlyOk: true
      });
    }
  },
  room_enter_failed (e) {
    const { reason } = e.data

    switch (reason) {
      case 'NOT_AUTHORIZED_USER':
        this.$alert({
          text: this.$t('room.unableConnectUser'),
          ok: () => {
            this.unsetBeforeUnloadEvent();
            window.location.href = 'service/room'
          },
          onlyOk: true
        })
        break;
      default:
        break;
    }
  },
  room_cbt_end (e) {
    if (this.isParticipantRole()) {
      const myData = e.data.roomCbtUserScoreList.find(user => user.userId === this.me.userId);
      if (myData) {
        this.$alert({
          title: this.$t('roomCbt.endResult.title'),
          text: this.$t('roomCbt.endResult.totalScore', { '0' : !myData.totalScore ? 0 : myData.totalScore }),
          onlyOk: true
        });
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.room {
  height: 100%;
  background-color: #eaeaea;
  display: flex;
  position: relative;

  .room-setting-layer {
    z-index: 5;
  }
}
.room-main {
  min-width: 0;
  flex: 1;
  background: linear-gradient(170deg, #0a0a15, #545f6f);
  position: relative;
  z-index: 1;
}
.room-container {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

// Component
.room-main-component {
  height: 100%;
}
.room-controls-component {
  height: 50px;
  position: relative;
  z-index: 3;
}
.room-call-sub-video-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.room-menu-component {
  width: 60px;
  z-index: 4;
}
.room-setting-component {
  width: 360px;
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: calc(60px + 6px);
  z-index: 2;
}
.room-sticker-modal-component {
  width: 80px;
  position: absolute;
  top: calc(50px + 6px);
  right: 0;
  bottom: 6px;
  left: calc(60px + 6px);
  z-index: 2;
}
[grm-device-mobile] {
  @media (max-width: 768px) {
    .room-container {
      width: 100%;
    }
    .room-setting-component{
      width: calc(100% - 72px);
    }
  }
}
</style>